import type { ReactNode } from "react";

export interface PageContainerProps {
  children: ReactNode;
  className?: string;
  maxWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl" | "6xl" | "7xl";
  padding?: boolean;
}

const maxWidthClasses = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "2xl": "max-w-2xl",
  "3xl": "max-w-3xl",
  "4xl": "max-w-4xl",
  "5xl": "max-w-5xl",
  "6xl": "max-w-6xl",
  "7xl": "max-w-7xl",
};

export function PageContainer({
  children,
  className = "",
  maxWidth = "7xl",
  padding = true,
}: PageContainerProps) {
  const maxWidthClass = maxWidthClasses[maxWidth];
  const paddingClass = padding ? "px-4 sm:px-6 lg:px-8 py-8" : "";

  return (
    <div className={`${maxWidthClass} mx-auto ${paddingClass} ${className}`}>
      {children}
    </div>
  );
}
